import { render, staticRenderFns } from "./ReportProofsForm.vue?vue&type=template&id=ce4f6814&scoped=true&"
import script from "./ReportProofsForm.vue?vue&type=script&lang=ts&"
export * from "./ReportProofsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReportProofsForm.vue?vue&type=style&index=0&id=ce4f6814&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4f6814",
  null
  
)

export default component.exports